﻿import { type AuditHistoryData } from '../types/modules/dynamic-audit-history';

function getAuditHistoryGrid(data: AuditHistoryData) {
    const localeDict = window.getLocaleDict().dynamicAuditHistory;
    const grid = $('#auditHistoryGrid').kendoGrid({
        dataSource: {
            transport: {
                read: '/AuditHistory/GetFiltered',
                dataType: 'json',
                parameterMap: () => data
            },
            pageSize: 20,
            schema: {
                data: 'Data',
                total: 'Total',
                model: {
                    id: 'Id',
                    fields: {
                        Id: { type: 'number' },
                        Value: { type: 'string' },
                        CreatedOn: { type: 'string' },
                        CreatedByCardUrlLink: { type: 'string' }
                    }
                }
            },
            serverPaging: true
        },
        groupable: false,
        sortable: false,
        pageable: {
            refresh: true,
            pageSizes: true,
            buttonCount: 5
        },
        columnMenu: false,
        columns: [
            {
                field: 'Id',
                title: 'Id',
                width: 60
            },
            {
                field: 'Value',
                title: localeDict.valueColumn,
                width: 180,
                template: '# if (data.Value) {# #=data.Value# #} else {# <span>&\\#10060;</span> #}#'
            },
            {
                field: 'CreatedOn',
                title: localeDict.changedDateColumn,
                width: 180,
                template: '#= kendo.toString(kendo.parseDate(data.CreatedOn), "dd.MM.yyyy HH:mm") #'
            },
            {
                field: 'CreatedByCardUrlLink',
                title: localeDict.changedByColumn,
                width: 180,
                template: '# if (data.CreatedByCardUrlLink) {# #=data.CreatedByCardUrlLink# #} else {# <span>&\\#10060;</span> #}#'
            }
        ],
        dataBound({ sender }: kendo.ui.GridDataBoundEvent) {
            window.setColorCellsWithValueYesNoUnknown(sender);
        }
    });

    return grid.data('kendoGrid');
}

function getWndAuditHistory(data: AuditHistoryData) {
    const localeDict = window.getLocaleDict().dynamicAuditHistory;
    const wnd = document.createElement('div');
    document.body.appendChild(wnd);
    $(wnd).html('<div id="auditHistoryGrid"></div>');

    const instance = $(wnd).kendoWindow({
        animation: false,
        pinned: true,
        title: localeDict.auditHistoryTitle,
        width: 800,
        actions: [
            'Close'
        ],
        close: (event) => {
            event.sender.destroy();
            wnd.remove();
        }
    }).data('kendoWindow');

    instance?.center().open();
    getAuditHistoryGrid(data);
}

function getButtonHistory(btnElement: HTMLButtonElement, data: AuditHistoryData) {
    return $(btnElement).kendoButton({
        imageUrl: '/history.svg',
        click: () => {
            getWndAuditHistory(data);
        }
    });
}

window.getButtonHistory = getButtonHistory;
window.getWndAuditHistory = getWndAuditHistory;
